import axios from 'axios'
import appConfig from '@/appconfig'
import apipath from '@constants/apipath'
import store from '../store'
import getSavedState from '../../utils/get-state'
import saveState from '../../utils/save-state'

export const state = {
  cached: [],
  lenderId: getSavedLenderState('lenders.lenderId'),
  selectedCustomerName: getSavedState('selectedCustomerName'),
}
export const getters = {
  selectedCustomerName: (state) => {
    return state.selectedCustomerName
  },
}

export const mutations = {
  SET_SELECTED_CUSTOMER_NAME(state, customerName) {
    state.selectedCustomerName = customerName
    saveState('selectedCustomerName', customerName)
  },
}

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },

  // getPrequalTemplate code start
  async getPrequalTemplate({ commit }, customerID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${apipath.adminApiPath.getPrequalTemplate}/${customerID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch(function(error) {
        return error
      })
  },
  // getPrequalTemplate code ends
  // logo code start
  async getcustomerlogo({ commit }, { customerID }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${apipath.adminApiPath.getCustomerLogo}/${customerID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch(function(error) {
        return error
      })
  },
  // logo code ends

  // getAppPageStyle code starts
  async getAppPageStyle({ commit }, { customerID, pageID }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${apipath.adminApiPath.getAppPageStyle}/${customerID}/${pageID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch(function(error) {
        return error
      })
  },
  // getAppPageStyle code ends

  // savePrequalTemplate code start
  async savePrequalTemplate({ commit }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${apipath.adminApiPath.savePrequalTemplate}`,
        payload,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error
      })
  },
  // savePrequalTemplate code ends

  // saveAppPageStyle code start
  async saveAppPageStyle({ commit }, { appPageData }) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${apipath.adminApiPath.saveAppPageStyle}`,
        appPageData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error
      })
  },
  // saveAppPageStyle code ends

  // saveProdpagestyle code start
  async saveProdPageStyle({ commit }, { productData } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${apipath.adminApiPath.saveAppPageStyle}`,
        productData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error
      })
  },
  // saveprodpagestyle code ends
}

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
function getSavedLenderState(key) {
  if (window.localStorage['lenders'] !== 'undefined')
    return JSON.parse(window.localStorage.getItem(key))
  else return null
}
function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
